import React from "react";
import useVariables from "../../../../../common/hooks/useVariables";
import { Link, useLocation, useParams } from "react-router-dom";
import { Breadcrumb } from "antd";
import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setcurrentgroupindex } from "../../../../../Store/Features/MatchesSlice";

const useRoundsButtons = () => {
  const { state } = useLocation();
  const { id } = useParams();
  const Matches = useSelector((state) => state.matches.matches);
  const currntgroupindex = useSelector((state) => state.matches.currntgroupindex);
  const dispatch = useDispatch();
  const HistoryButtons = ({ origin, loading }) => {
    const { FLAG } = useVariables();
    if (loading) return null;

    return (
      <Breadcrumb separator=">" style={{ padding: "0 0 2% 2.5%" }}>
        <Breadcrumb.Item>
          <Link to={`/${FLAG}`}>Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/view/event/${id}`}>Event</Link>
        </Breadcrumb.Item>
        {origin === "groupstages" ? (
          <Breadcrumb.Item>
            <Link state={state} to={`/view/event/${id}/matches`}>
              Matches
            </Link>
          </Breadcrumb.Item>
        ) : null}

        {origin === "multiplayer" ? (
          <Fragment>
            {Matches?.rounds?.map((match, index) => {
              return (
                <Breadcrumb.Item
                  status="active"
                  key={match}
                  className={currntgroupindex?.currentourndindex === index ? "activecrumb" : ""}
                  onClick={() =>
                    dispatch(
                      setcurrentgroupindex({ ...currntgroupindex, currentourndindex: index })
                    )
                  }>
                  <span style={{ cursor: "pointer" }}>
                    {match?.[0]?.nameofRound ? match?.[0]?.nameofRound : `Round ${index + 1}`}
                  </span>
                </Breadcrumb.Item>
              );
            })}
          </Fragment>
        ) : null}
        {origin === "history" ? (
          <Fragment>
            <Breadcrumb.Item>
              <Link state={state} to={`/view/event/${id}/knock-out-matches`}>
                Knockouts
              </Link>
            </Breadcrumb.Item>
            {state?.typeofmatch === "league" ? (
              <Breadcrumb.Item>
                <Link state={state} to={`/view/event/${id}/history`}>
                  History
                </Link>
              </Breadcrumb.Item>
            ) : null}
          </Fragment>
        ) : null}
        {/* knockouts */}
        {
          <Fragment>
            {origin === "knockouts" ? (
              <Fragment>
                {state?.typeofmatch === "league" ? (
                  <Breadcrumb.Item>
                    <Link state={state} to={`/view/event/${id}/history`}>
                      History
                    </Link>
                  </Breadcrumb.Item>
                ) : null}

                <Breadcrumb.Item>
                  <Link state={state} to={`/view/event/${id}/knock-out-matches`}>
                    Knockouts
                  </Link>
                </Breadcrumb.Item>
              </Fragment>
            ) : null}
          </Fragment>
        }
      </Breadcrumb>
    );
  };

  return { HistoryButtons };
};

export default useRoundsButtons;
